import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Radio from 'components/global/Radio';

import { Breakpoints } from 'utils/const.styles';

export const StyledContainer = styled.div`
	width: 100%;
`;

export const SectionContainer = styled.div`
	width: 100%;
	margin: 2rem 0;
	.mb-2-5 {
		margin-bottom: 2rem;
	}
`;

export const SectionTitle = styled.div`
	margin-bottom: 2.5rem;
`;

export const Line = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin: 2.5rem 0;
	width: 100%;
`;

export const FormContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 1rem;
	width: 100%;
	justify-content: space-between;
	.form-item {
		margin: 0 !important;
		padding-right: 0;
		padding-left: 0;
	}
	& > div {
		width: 49% !important;
	}
	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		gap: 0.5rem;
		& > div {
			width: 100% !important;
		}
	}
`;

export const AccountTypeContainer = styled.div`
	/* if account type is KSA or UAE then show 3 types in grid
	 * else show 2 type in grid, because of the freelance type 
	 * is not available in TR 
	*/
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-gap: 2.5rem;

	@media ${Breakpoints.mobileLandscape} {
		grid-template-columns: repeat(2, 1fr);
	}
	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(1, 1fr);
	}
	&:has(:nth-of-type(3)) {
		grid-template-columns: repeat(3, 1fr);
		@media ${Breakpoints.mobileLandscape} {
			grid-template-columns: repeat(2, 1fr);
		}
		@media ${Breakpoints.mobile} {
			grid-template-columns: repeat(1, 1fr);
		}
	}
`;

export const AccountTypeCard = styled(Card)`
	display: flex;
	flex-direction: row;
	width: 100%;
	padding: 3.5rem 2.5rem;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	:hover {
		border: 1px solid var(--blue);
	}
	&.selected {
		border: 1px solid var(--blue);
		background-color: var(--background-1);
	}
`;

export const AccountTypeHeader = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 1rem;
`;

export const AccountTypeContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 70%;
`;

export const StyledRadio = styled(Radio)`
	flex: 0 0 auto;
`;
